import classNames from "classnames";
import React from "react";
import { useChildrenArray } from "../../../lib/helpers/hooks/useChildrenArray";
import styles from "./AscAdminDropdownOption.module.scss";

export interface AscAdminDropdownOptionProps {
  children: React.ReactNode;
  onClick?: () => void;
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

export function AscAdminDropdownOption({ children }: AscAdminDropdownOptionProps) {
  return <>{children}</>;
}

interface AscAdminDropdownOptionsContainerProps {
  children?: JSX.Element[];
  header?: React.ReactNode;
  close?: () => void;
  className?: string;
  optionItemClassName?: string;
}

export function AscAdminDropdownOptionsContainer({
  children,
  header,
  close,
  className,
  optionItemClassName,
}: AscAdminDropdownOptionsContainerProps) {
  const options = useChildrenArray<AscAdminDropdownOptionProps>(children || []);
  return (
    <div className={classNames(styles.selectOptionsContainer, className)}>
      {header}
      <ul>
        {options.map((option, index) => {
          return (
            <li
              key={index}
              onClick={() => {
                if (option?.disabled) {
                  return;
                }
                option?.onClick?.();
                close?.();
              }}
              className={classNames(
                styles.selectOption,
                {
                  [styles.disabled]: option?.disabled,
                },
                option?.className,
                optionItemClassName
              )}
            >
              {option?.prefixIcon ? (
                <span className={styles.icon}>{option?.prefixIcon}</span>
              ) : null}
              <div className={styles.content}>{option?.children}</div>
              {option?.suffixIcon ? (
                <span className={styles.icon}>{option?.suffixIcon}</span>
              ) : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
